import {
  getStoryblokImageServiceUrl,
  SbBlokData,
  type StoryblokImage,
  type Video,
} from '@cinch-nx/data-storyblok'
import { BaseCard, usePrefersReducedMotion } from '@cinch-nx/shared-ui'
import { useRouter } from 'next/router'
import { Skeleton } from '@mui/material'
import {
  landingStoryblokComponents,
  StoryblokRenderer,
} from '@cinch-nx/landing-ui-shared'

import styles from './header.module.css'

export interface Props {
  authorByline?: {
    block: SbBlokData[]
    publishedDate?: string | null
  }
  title: string
  subTitle?: string
  image?: StoryblokImage
  video?: Video[]
}

export const ArticleHeader: React.FC<Props> = ({
  authorByline,
  title,
  subTitle,
  image,
  video,
}) => {
  const { isFallback } = useRouter()
  const prefersReducedMotion = usePrefersReducedMotion()

  if (isFallback) {
    return (
      <header className={styles['header']}>
        <Skeleton
          sx={{ marginBottom: '16px' }}
          animation={prefersReducedMotion ? false : 'wave'}
          variant="rectangular"
          width={250}
          height={61}
        />
        <Skeleton
          sx={{ marginBottom: '16px' }}
          animation={prefersReducedMotion ? false : 'wave'}
          variant="rectangular"
          width={750}
          height={56}
        />
      </header>
    )
  }

  return (
    <header className={styles['header']}>
      <h1 className={styles['title']} data-testid="article-title">
        {title}
      </h1>
      {subTitle && <p className={styles['subTitle']}>{subTitle}</p>}
      {authorByline && (
        <StoryblokRenderer
          block={authorByline.block}
          components={landingStoryblokComponents}
          props={{
            latestPublishDate: authorByline.publishedDate,
          }}
        />
      )}
      {(video?.length ?? 0) <= 0 && image?.filename ? (
        <BaseCard className={styles['imageWrapper']}>
          <img
            src={getStoryblokImageServiceUrl(image.filename, {
              height: 639,
              width: 960,
              filters: [{ quality: 80 }],
              fitIn: { width: 960, height: 639 },
            })}
            alt={image.alt || 'article hero'}
          />
        </BaseCard>
      ) : null}
    </header>
  )
}
